// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2GabW","checkboxCol":"Table_checkboxCol__WTCZn","emailCol":"Table_emailCol__3xjHc","actionCol":"Table_actionCol__TtL1M"};